"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Pill = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix,
    iconOnly,
    label,
    selected,
    disabled,
    small,
    thumbnail,
    ssrIcon,
    iconPosition,
    thumbnailAlt,
    className,
    onClick,
    ...other
  } = props;
  const baseClass = `${prefix}pill`;
  const pillClasses = (0, _classnames.default)(`${baseClass}`, small && `${baseClass}--small`, iconOnly && ssrIcon && !thumbnail && `${baseClass}--icon`, !iconOnly && ssrIcon && !thumbnail && `${prefix}${iconPosition}-icon`, thumbnail && `${baseClass}--thumbnail`, selected && !disabled && `${baseClass}--active`, className);
  return _react.default.createElement("button", _extends({
    ref: ref,
    className: pillClasses,
    disabled: disabled,
    "aria-pressed": selected ? 'true' : 'false',
    onClick: onClick
  }, other), thumbnail && _react.default.createElement("img", {
    className: `${baseClass}__thumbnail`,
    src: thumbnail,
    alt: thumbnailAlt
  }), ssrIcon && !thumbnail && _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon,
    className: `${baseClass}__icon`
  }), label && _react.default.createElement("span", {
    className: `${baseClass}__label`
  }, label));
});
Pill.defaultProps = {
  prefix: '',
  iconPosition: 'leading'
};
Pill.displayName = 'Pill';
var _default = Pill;
exports.default = _default;